<template>
  <div class="add_box">
    <el-form
      :model="toAdDas"
      :rules="toAdRule"
      label-position="right"
      label-width="200px"
      ref="ruleForm"
      style="width: 90%; margin: 20px auto"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              placeholder="请输入内容"
              v-model="toAdDas.activityName"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="投票次数" prop="limitDay">
            <el-input
              type="number"
              placeholder="请输入内容"
              v-model="toAdDas.limitDay"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="活动时间" prop="value1">
            <el-date-picker
              clearable
              end-placeholder="活动结束日"
              range-separator="至"
              size="small"
              start-placeholder="活动起始日"
              type="daterange"
              v-model="toAdDas.value1"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="封面图" prop="coverUrl" ref="coverUrl">
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="TopicSuccess"
            >
              <img
                v-if="toAdDas.coverUrl"
                :src="toAdDas.coverUrl"
                class="avatar"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="活动介绍" prop="introduce">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="toAdDas.introduce"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="活动规则" prop="rule">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
              v-model="toAdDas.rule"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          style="margin-left: 200px"
          type="primary"
          @click="submitAdd('ruleForm')"
          >保存</el-button
        >
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  data() {
    var valiImg = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.toAdDas.coverUrl == "") {
        callback(new Error("封面图不能为空"));
      } else {
        callback();
      }
    };
    return {
      loadUpt: false,
      // 添加的参数
      toAdDas: {
        activityName: "", //活动名称
        value1: "", //活动时间
        introduce: "", //活动介绍
        coverUrl: "", //封面图
        rule: "", //活动规则
        limitDay: "", //一人一天投票次数上限
      },
      toAdRule: {
        activityName: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        rule: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        value1: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        introduce: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        limitDay: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        coverUrl: [{ required: true, validator: valiImg, trigger: "blur" }],
      },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
    };
  },
  methods: {
    TopicSuccess(file) {
      this.toAdDas.coverUrl = file.entity;
      if (file.entity) {
        this.$refs.coverUrl.clearValidate();
      }
    },
    // 添加投票活动
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/vote/insert", {
            activityName: this.toAdDas.activityName, //活动名称
            startDate: this.toAdDas.value1[0], //活动起始时间
            endDate: this.toAdDas.value1[1], //活动结束时间
            introduce: this.toAdDas.introduce, //活动介绍
            coverUrl: this.toAdDas.coverUrl, //封面图
            rule: this.toAdDas.rule, //活动规则
            limitDay: this.toAdDas.limitDay, //一人一天投票次数上限
          }).then((res) => {
            if (res.success) {
              this.$message.success(res.message);
              this.$router.push("/vote");
            } else if (res.success && res.statusCode == 401) {
              this.$router.push("/");
              this.$message.error(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.avatar-uploader {
  width: 200px;
  height: 200px;
  line-height: 200px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  outline: 0;
  border: 2px dashed #eee;
}
.el-upload img {
  width: 200px;
  height:auto;
}
</style>